const Vr16 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-16/PNG%20n.4/3d%2016-4/publish%2016-4/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 16 Tour"
        ></iframe>
      </div>
    );
};

export default Vr16;
